import React from "react";
import { Helmet } from "react-helmet";

function SEO({ title, description, keywords, image, url, author = "Ibtehaz" }) {
  const siteName = "Ibtehaz.XYZ";
  const defaultTitle = `${siteName} | Sharing Stories and Insights`;
  const defaultDescription =
    "Thoughts, creations, and insights by Ibtehaz — a digital notebook for ideas that matter.";
  const defaultKeywords = "blog, articles, stories, insights, My Blog";
  const siteUrl = "https://ibtehaz.xyz";
  const defaultImage = `${siteUrl}/images/default-og-image.jpg`;

  const fullTitle = title ? `${title} | ${siteName}` : defaultTitle;
  const metaDescription = description || defaultDescription;
  const metaKeywords = keywords || defaultKeywords;
  const metaUrl = url || siteUrl;
  const metaImage = image || defaultImage;

  return (
    <Helmet>
      {/* Basic meta tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={metaKeywords} />
      <meta name="author" content={author} />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta charSet="utf-8" />

      {/* Open Graph tags */}
      <meta name="title" property="og:title" content={fullTitle} />
      <meta name="description" property="og:description" content={metaDescription} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={metaUrl} />
      <meta name="image" property="og:image" content={metaImage} />

      {/* Twitter Card tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={metaImage} />

      {/* Favicon + theme color (optional, adjust paths) */}
      <link rel="icon" href="/favicon.ico" />
      <meta name="theme-color" content="#ffffff" />
    </Helmet>
  );
}

export default SEO;
